// src/tasks/TaskTable.jsx
import { useEffect, useState } from "react";
import api from "../../api";
import EditTaskModal from "./EditTaskModal";
import { Table, Button, Badge } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian"; // Import gregorian here too

const TaskTable = ({ tasks = [], onRefresh }) => {
  const [editingTask, setEditingTask] = useState(null);

  const remove = id => {
    api.delete(`/tasks/${id}/`).then(onRefresh);
  };

  const TASK_STATUS_LABELS = {
    assigned: "اختصاص داده شده",
    in_progress: "در حال انجام",
    completed: "تکمیل شده",
  };

  // تابع کمکی برای تبدیل اعداد فارسی به انگلیسی (نیاز است در TaskTable هم باشد)
  const toEnglishDigits = str =>
    str?.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

  const formatTaskDeadline = (deadline) => {
    if (!deadline) return { formatted: "-", remainingDays: null };

    try {
      // این خط اطمینان حاصل می کند که ورودی به DateObject، انگلیسی است
      const englishDeadlineString = toEnglishDigits(deadline) || deadline;

      // این خط ورودی را به عنوان تاریخ میلادی در نظر می گیرد
      const dateObject = new DateObject({
        date: englishDeadlineString,
        calendar: gregorian, // تاریخ ورودی میلادی است
        locale: persian_fa,
      });

      // تبدیل به تاریخ شمسی
      const persianDateObject = dateObject.convert(persian);
      const formattedDate = persianDateObject.format("YYYY/MM/DD");

      const today = new DateObject({ calendar: persian, locale: persian_fa });
      const remainingDays = persianDateObject.toDays() - today.toDays();

      return { formatted: formattedDate, remainingDays };
    } catch (error) {
      console.error("Error formatting date:", error);
      // اگر تبدیل انجام نشد، تاریخ اصلی را برمی‌گرداند
      return { formatted: deadline, remainingDays: null };
    }
  };


  const getDeadlineStyle = (remainingDays) => {
    if (remainingDays === null) return {};
    if (remainingDays < 0) return { color: "red", fontWeight: "bold" };
    if (remainingDays < 3) return { color: "orange", fontWeight: "bold" };
    return {};
  };

  return (
    <>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th>عنوان</th>
            <th>توضیحات</th>
            <th>سررسید تحویل</th>
            <th>کاربر</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map(t => {
            const { formatted: formattedDeadline, remainingDays } = formatTaskDeadline(t.deadline);
            const deadlineStyle = getDeadlineStyle(remainingDays);

            return (
              <tr key={t.id}>
                <td>{t.title}</td>
                <td>{t.description || "-"}</td>
                <td style={deadlineStyle}>
                  {formattedDeadline}
                  {remainingDays !== null && (
                    <span style={{ marginLeft: '8px' }}>
                      ({remainingDays > 0 ? `${remainingDays} روز مانده` : remainingDays < 0 ? `گذشته` : `امروز`})
                    </span>
                  )}
                </td>
                <td>{t.assigned_to_username || "-"}</td>
                <td>
                  <Badge
                    bg={
                      t.status === "completed"
                        ? "success"
                        : t.status === "in_progress"
                        ? "warning"
                        : "secondary"
                    }
                  >
                    {TASK_STATUS_LABELS[t.status]}
                  </Badge>
                </td>
                <td className="d-flex justify-content-center gap-2">
                  <Button
                    className="btn-edit"
                    size="sm"
                    variant="outline-primary"
                    onClick={() => setEditingTask(t)}
                  >
                    ویرایش
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => remove(t.id)}
                  >
                    حذف
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      <EditTaskModal
        show={!!editingTask}
        task={editingTask}
        onHide={() => setEditingTask(null)}
        onUpdated={onRefresh}
      />
    </>
  );
};

export default TaskTable;